const errors = {
  'auth/network-request-failed': 'Ops, parece que você está offline. Tente novamente em alguns instantes.',
  'auth/email-already-in-use': 'Você já possui um cadastro no Investtor com esse e-mail.',
  'auth/invalid-email': 'E-mail inválido.',
  'auth/user-not-found': 'E-mail ou senha incorretos.',
  'auth/wrong-password': 'E-mail ou senha incorretos.',
}

export const getMessageByCode = errCode => errors[errCode]
